import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTruck,
  faDroplet,
  faCar,
  faLayerGroup,
  faTruckMoving,
} from '@fortawesome/free-solid-svg-icons';
import FieldTitle from '../../../components/agv-forms-title';

const VEHICLE_TYPES = [
  { value: 'Baché', label: 'Baché', icon: faTruckMoving },
  { value: 'Citerne', label: 'Citerne', icon: faDroplet },
  { value: 'Citerne compartimentée', label: 'Citerne comp.', icon: faLayerGroup },
  { value: 'Véhicule léger', label: 'Véh. léger', icon: faCar },
  { value: 'Plateau', label: 'Plateau', icon: faTruckMoving },
];

export default function VehicleTypeRadio({
  value,
  setValue,
  fieldTitle,
  isRequired,
}) {
  return (
    <div className="tw-flex tw-flex-col">
      {fieldTitle && <FieldTitle title={fieldTitle} isRequired={isRequired} />}
      <div className="tw-mt-2">
        <div className="tw-flex tw-gap-3 tw-justify-between">
          {VEHICLE_TYPES.map((type) => (
            <button
              key={type.value}
              type="button"
              onClick={() => setValue(type.value)}
              className={`
                tw-group tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-3 tw-px-4 tw-font-medium tw-text-xs tw-transition-all tw-flex-1 tw-rounded-lg
                ${
                  value === type.value
                    ? 'tw-bg-primary tw-text-white tw-border-none'
                    : 'tw-bg-gray-50 tw-text-gray-600 hover:tw-bg-gray-300 tw-border tw-border-gray-200'
                }
              `}
            >
              <FontAwesomeIcon
                icon={type.icon}
                className={`tw-text-xl ${
                  value === type.value ? 'tw-text-white' : 'tw-text-gray-400 group-hover:tw-text-gray-500'
                }`}
              />
              <span className="tw-text-center tw-leading-tight">{type.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

